import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=6836379a"
import script from "./Attribute.vue?vue&type=script&lang=js"
export * from "./Attribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports